import { Select } from "antd";
import { specialSubCategories } from "modules/utilities/utility";
import { useCategoryData } from "pages/store";
import React, { useEffect, useState } from "react";
import {
  Accordion,
  Button,
  Form,
  FormControl,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import MedicalCreateTicketSlot from "./MedicalCreateTicketSlot";
import { useParams } from "react-router-dom";
import { createMeidcalEscalationTicket } from "modules/navbar/top/store";
import moment from "moment";
import MedicalSlotBooking from "./MedicalSlotBooking";
import _ from "lodash";
import InputFeedBack from "./InputFeedBack";

function SubSection2({ slotBookingData, setSlotBookingData, deliveredOrders }) {
  const [apiSubCategory, setApiSubCategory] = useState([]);
  const { fetchCategoryData, categorySubcatData } = useCategoryData();
  const medicalEscalationId = "650192d8ad8f3c4205580407";
  const [subCatKey, setSubCatKey] = useState("");
  const [slotObject, setSlotObject] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const { nearestSlot, fetchNearestSlot } = createMeidcalEscalationTicket();
  const [selectSubCat, setSelectSubCat] = useState(false);
  const [ticketObject, setTicketObject] = useState(null);
  const { id } = useParams();
  const latestDeliverOrder = _.get(deliveredOrders, "[0].order_display_id");
  useEffect(() => {
    setApiSubCategory(categorySubcatData?.data?.subcategory);
  }, [categorySubcatData]);
  const medicalEscSubCat =
    categorySubcatData?.data?.subcategory[medicalEscalationId];
  const handleSubCatChange = (subCat) => {
    if (subCat !== undefined) {
      const foundObject = medicalEscSubCat.find((obj) => {
        return obj.value === subCat.target.value;
      });
      setSelectSubCat(true);
      setSubCatKey(foundObject.key);
    } else {
      setSubCatKey("");
    }
  };
  useEffect(() => {
    fetchCategoryData();
  }, []);
  useEffect(() => {
    setApiSubCategory(categorySubcatData?.data?.subcategory);
  }, [categorySubcatData]);

  useEffect(() => {
    fetchNearestSlot();
  }, []);

  const handleCheckboxNames = ["referredToSOP", "needToRaiseTicket"];
  console.log("nearestSlot", nearestSlot);
  const handleCheckboxChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    if (handleCheckboxNames.includes(name)) {
      const checkedValue = event.target.checked;
      setSlotBookingData((prevFormData) => ({
        ...prevFormData,
        [name]: checkedValue,
      }));
    } else {
      setSlotBookingData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };
  // console.log("ticketObject.sub_category", ticketObject.sub_category);
  return (
    <Accordion>
      <Accordion.Item eventKey="1">
        <Accordion.Header className="border-bottom">
          Product / Medical Reaction
        </Accordion.Header>
        <Accordion.Body>
          <Form.Check
            type="checkbox"
            label="Referred to the side effect SOP"
            checked={slotBookingData?.referredToSOP}
            onChange={handleCheckboxChange}
            className="mb-2"
            id="referredToSOP"
            name="referredToSOP"
          />
          <Form.Label className="text-primary">Sub Categories</Form.Label>
          {/* <Form.Select
            className="form-control"
            id="sub_category"
            required
            lab
            onChange={handleSubCatChange}
          >
            <option className="d-none" value="">
              {" "}
            </option>
            {medicalEscSubCat?.map((option, index) =>
              option.source && option.source.includes("CRM") ? (
                <option key={option.key} value={option.value}>
                  {option.label}
                </option>
              ) : null
            )}
          </Form.Select> */}
          <InputFeedBack
            setFormData={setSlotBookingData}
            formData={slotBookingData}
            orders={deliveredOrders}
            orderDisplayId={latestDeliverOrder}
            setTicketObject={setTicketObject}
          />
          {/* {ticketObject &&
          !specialSubCategories.includes(ticketObject.sub_category) ? ( */}
          {ticketObject && ticketObject.sub_category && (
            <div className="mt-2">
              <div>
                <MedicalSlotBooking
                  caseId={id}
                  formCategory={ticketObject.sub_category}
                  slotBooking={true}
                  orderDisplayId={latestDeliverOrder}
                  ticketObject={ticketObject}
                  setTicketObject={setTicketObject}
                />
              </div>
              {/* <Button
                className="mt-5 py-2 fs-1 w-100 mb-3"
                onClick={handleBookSlot}
              >
                <span className="d-flex flex-row gap-2 justify-content-center">
                  <span>Create Ticket</span>
                </span>
              </Button> */}
            </div>
          )}
          {/* ) : (
            <>
              {ticketObject.sub_category && ticketObject.sub_category && (
                <InputGroup className="mt-4 mb-2">
                  <InputGroup.Text id="inputGroup-sizing-default">
                    <h4 className="p-0 m-0">Nearest Slot</h4>
                  </InputGroup.Text>
                  <FormControl
                    aria-label="Default"
                    className="fs-2"
                    disabled
                    value={
                      nearestSlot
                        ? moment(nearestSlot?.slot_time).format(
                            "hh:mm, MMMM Do YYYY"
                          )
                        : "-"
                    }
                    aria-describedby="inputGroup-sizing-default"
                  />
                </InputGroup>
              )}
            </>
          )} */}
          <Form.Check
            type="checkbox"
            label="Was there a need to raise a ticket? (Y/N)"
            checked={slotBookingData?.needToRaiseTicket}
            onChange={handleCheckboxChange}
            className="mb-2"
            id="needToRaiseTicket"
            name="needToRaiseTicket"
          />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}

export default SubSection2;
